import type { FaireProductEntity } from "../../entity_types/product";

export const p_uu43zc43dr: FaireProductEntity = {
  token: "p_uu43zc43dr",
  type: "product",
  name: "Long Loose Solid Color Long Sleeves Knit Cardigan MMY299",
  brandToken: "b_9qqlp5kqt7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2d6989ad86ac0de9dcda196bb410b6a7656c6f7a6d4b7c6af95ce8147cec7517.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63d261284fc6018410e43592e0e4a9d24330a80e6df7c05816a687cd2b1a07c9.jpeg",
    "https://cdn.faire.com/fastly/2259469469db6df1cbbbfd422b575d37b96aa1cf38264970bfc37aa68a1e3680.jpeg",
    "https://cdn.faire.com/fastly/e2bdae0c319bc26bae6a916f29e743be0f09189f3df2f8cb8678717709c038c7.jpeg",
    "https://cdn.faire.com/fastly/b541cc4eec2bf824fd07ace9952d8c5a377ee5d36f85453a2ddaeb704c0dae01.jpeg",
    "https://cdn.faire.com/fastly/388b0f7c5ca1892e67c8fe9cf9d52c8ca7375be1cf9cc8be294376ec3d0c77ba.jpeg",
    "https://cdn.faire.com/fastly/d8cda642c02cb657935d8beaa451ea8616270f72b5dba28d682ed58a3d10e6b9.jpeg",
  ],
  priceDollars: 29.79,
  description:
    "Long Loose Solid Color Long Sleeves Knit Cardigan MMY299\n\nCozy Longline Design: The extended length creates a relaxed silhouette, perfect for layering on chilly days.\n\nSolid Color Simplicity: Minimalist single-tone design makes it versatile and easy to style with different outfits.\n\nSoft Knit Comfort: Made from breathable knit fabric, offering warmth while remaining lightweight and comfortable.\n\nRelaxed Loose Fit: Loose tailoring provides effortless comfort and freedom of movement without feeling restrictive.\n\nEveryday Wardrobe Essential: Suitable for casual wear, office layering, or lounging at home, this cardigan is a timeless staple.\n\nSize Chart (cm)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t104.00 \t48.0 \t96.0 \nM\t108.00 \t49.0 \t97.0 \nL\t114.00 \t50.0 \t99.0 \nXL\t120.00 \t51.0 \t101.0 \n\nSize Chart (inch)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t40.9 \t18.9 \t37.8 \nM\t42.5 \t19.3 \t38.2 \nL\t44.9 \t19.7 \t39.0 \nXL\t47.2 \t20.1 \t39.8 \n",
  tags: [],
  msrpDollars: 59.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:41.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
